
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { post } from 'request/request'
import { selectLocale } from 'store/localeSlice'
import './newsDetail.less'
import { useParams } from 'react-router'
import moment from 'moment'
import { Space } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
export const NewsDetail = () => {
    const {id} = useParams<{id: string}>()
    const [newsDetail, setNewsDetail] = useState<{[key in string] : any}>({})
    const locale= useSelector(selectLocale);
    const [isLoading, setIsLoading] = useState(true)
    
    const publish = () => { 
        switch (locale) {
          case 'en':
            return 'Publish'
          case 'ja':
            return '発表'
          case 'ko':
            return '발표'
          case 'zh':
            return '发表'
          default:
            return 'Publish'
        }
      }
    useEffect(() => {
        post('snailcar/website/common/queryNews',{pageNo: 1,pageSize: 999,newsId: id}, {headers: {language: locale}}).then((data:any) => {
            if (data.resultCode === '200' ){
                setNewsDetail(data.resultBody.data.list.find((Item:any) => Item.newsId == id) || {})
                setIsLoading(false)
            }
        })
    }, [])
    return isLoading ? <div className='pages_loading'><LoadingOutlined /></div> : <div className='news-detail-template-wrapper'>
        <div className='news_detail_title'>{newsDetail.name}</div>
        <Space  className='time'>
            <span>{newsDetail.createTime ? moment(newsDetail.createTime).format('YYYY-MM-DD HH:mm:ss') : ''}</span>
            <span>{publish()}</span>
        </Space>
        <div className='news_detail_wrapper' dangerouslySetInnerHTML={{ __html: newsDetail.detail}}></div>
    </div>
}